import { DECORATION_GROUP_INFO, GROUP_SETTING_PATH } from '@constant'
import { isSiDaProperty } from '@merchant-backend/util'
import { memberHasNoGroup } from '@util'
import cls from 'classnames'
import { Flex, Rating } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import Rowbox from '../Common/Rowbox'
import style from './style.module.less'

@inject('decorationStore')
@observer
export default class extends Component {
  onHref = () => {
    if (this.props.decorationStore.mode == 'preview') {
      return
    }

    hashHistory.push(
      memberHasNoGroup() ? '/localMerchant/groupManage' : GROUP_SETTING_PATH
    )
  }

  render() {
    const {
      decorationStore: { promiseData, newThemeConfig }
    } = this.props

    const { group } = promiseData || {}
    const { name, logo_path, merchant_comment, is_bond } = group || {}
    const { total_good_count, score } = merchant_comment || {}

    return (
      <Rowbox
        type={DECORATION_GROUP_INFO}
        store={this.props.decorationStore}
        style={{
          height: '80px',
          padding: '20px 16px'
        }}
        onClick={this.onHref}
      >
        {!group && <p>暂未加入团队</p>}
        {group && (
          <Flex vc>
            <img className={style.logo} src={logo_path} />

            <div>
              <div className={style.top}>
                <div className={cls(style.name, 'text-cut')}>{name}</div>

                {isSiDaProperty() &&
                  is_bond == 1 && (
                    <img
                      style={{ width: 50 }}
                      src="//qnm.hunliji.com/o_1dnr65cbf1c8fkdifmd175lomi9.png"
                    />
                  )}
              </div>

              <div className={style.bottom}>
                <>
                  <div className={style['bottom-item']}>
                    <Rating
                      value={Number(score)}
                      defaultStar={newThemeConfig['defaultStar']}
                      coverStar={newThemeConfig['coverStar']}
                      size={11}
                    />
                  </div>
                  <div
                    className={style['bottom-item']}
                    style={{ fontSize: 12 }}
                  >
                    <span style={{ marginRight: 4 }}>
                      {total_good_count > 999 ? '999+' : total_good_count}
                    </span>
                    <span>好评数</span>
                  </div>
                </>
              </div>
            </div>
          </Flex>
        )}
      </Rowbox>
    )
  }
}
